export default __webpack_public_path__ + "static/media/chat-orange.70f63afa.svg";